module.exports = __webpack_public_path__ + "static/media/brushsan-1.4ffc8f20.jpg";